import _ from "lodash";
import { useReducer } from "react";
import { analytics } from "src/localization/english/pages/asset";

export const RECORD_NEW_RANGE = 'RECORD_NEW_RANGE';
export const UPDATE_RANGE = 'UPDATE_RANGE';
export const SYNC_RANGES = 'SYNC_RANGES';

const initialState = {
  totalDuration: 0,
  segmentLength: 1,
  ranges: [],
  analytics: {
    progress: 0,
    duration: 0,
    percentageRead: 0,
    datapoints: []
  }
};

const reducer = (state, action) => {
  switch (action.type) {
    case RECORD_NEW_RANGE: {
      const { progress, range } = action;

      const ranges = [...state.ranges, range];
      return {
        ...state,
        ranges: [...state.ranges, range],
        analytics: processAnalytics(state, progress, ranges)
      };
    }

    case UPDATE_RANGE: {
      const { range } = action;

      const ranges = [...state.ranges].map(item => {
        if (item.id === range.id) {
          return {
            ...item,
            end: Math.max(item.start, item.end, range.end)
          }
        }

        return item;
      });

      return {
        ...state,
        ranges: ranges
      };
    }

    case SYNC_RANGES: {
      const { progress } = action;
      return {
        ...state,
        analytics: processAnalytics(state, progress || 0, state.ranges)
      };
    }

    default:
      return state;
  }
};

const processAnalytics = (state, progress, ranges) => {
  let duration = 0;

  const segmentLength = state.segmentLength;
  const totalDuration = state.totalDuration;
  const totalSegments = Math.round(totalDuration / segmentLength);

  const analyticsMaps = {};

  ranges.forEach(range => {
    const timeSpent = range.end - range.start;
    duration = duration + timeSpent;

    const startSegment = Math.floor(range.start / segmentLength);
    const endSegment = Math.floor(range.end / segmentLength);

    for (let i = startSegment; i <= endSegment; i++) {

      const key = parseInt(String(i));
      if (key >= totalSegments) {
        continue;
      }

      let datapoint = analyticsMaps[key];

      if (!datapoint) {
        datapoint = {
          index: key,
          views: 0,
          duration: 0
        };
      }

      const rangeStartSegment = Math.max(i * segmentLength, range.start);
      const rangeEndSegment = Math.min((i + 1) * segmentLength, range.end);

      const rangeDuration = rangeEndSegment - rangeStartSegment;
      const timeSpent = datapoint.duration + rangeDuration;

      datapoint = {
        ...datapoint,
        views: datapoint.views + 1,
        duration: timeSpent,
        completed: Math.ceil(rangeDuration) >= segmentLength
      }

      analyticsMaps[key] = datapoint;
    }
  });

  let datapoints = _.mapValues(analyticsMaps);
  datapoints = _.orderBy(datapoints, ["index", "asc"]) as any

  return {
    progress: progress,
    datapoints: datapoints,
    duration: _.reduce(datapoints, (prev, current: any) => {
      return prev + current.duration
    }, 0),
    percentageRead: calculatePercentageRead(state.totalDuration, totalDuration.segmentLength, datapoints)
  }
}

export const calculatePercentageRead = (totalDuration, segmentLength, datapoints) => {
  let totalSegments = Math.round(totalDuration / segmentLength);
  const segmentsViewedCount = _.size(datapoints);
  let percentage = 0;

  if (segmentsViewedCount > 0 && totalSegments == 0) {
    totalSegments = segmentsViewedCount;
  }

  if (totalSegments > 0 && segmentsViewedCount > 0) {
    percentage = segmentsViewedCount * 100 / totalSegments;
  }

  return percentage;
}

export const useAnalytics = (duration, segmentLength) => {
  return useReducer(reducer, {
    ...initialState,
    totalDuration: duration,
    segmentLength: segmentLength
  });
}